import styled from 'styled-components'

const DrawerContainer = styled.div`
  position: relative;
  width: ${(props) => props.width ?? 'inherit'};
`

export default DrawerContainer
